import { FireflyTertiaryButtonMenuItem } from '@equip.health/ui';

import { NO_NOTE_TEMPLATE_OPTION } from '~/lib/constants/notes';

export const noteTemplateRevisionsToDropdownOptions = (
  noteTemplateRevisions: NoteTemplateRevision[] | null,
): FireflyTertiaryButtonMenuItem[] => {
  if (!noteTemplateRevisions) {
    return [NO_NOTE_TEMPLATE_OPTION];
  }
  const options = noteTemplateRevisions.map((revision) => ({
    label: revision.template.templateTitle,
    node: revision.templateRevisionId,
  }));
  return [...options, NO_NOTE_TEMPLATE_OPTION];
};
